export default __webpack_public_path__ + "static/media/logo.93609fd4.svg";